import React from 'react';
import {connect} from "react-redux";
import CustomPaper from "./../../shared/utils/CustomPaper";
import Divider from 'material-ui/Divider';
import Block1 from "./indexBlocks/Block1";

class IndexBody extends React.Component {

    render() {
        return (
            <div className={'container'} style={{fontSize: 12}}>
                <CustomPaper title={'Espace salarié'}>
                    <Block1/>
                    <Divider/>
                </CustomPaper>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        infos: store.salarie.infos,
    }
}

export default connect(mapStateToProps)(IndexBody);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/IndexBody.js